import React from 'react';
import { Button } from '@mui/material';

export const CancelButton = props => {
  const { onClick, children, ...rest } = props;
  return (
    <Button {...rest} color="tertiary" onClick={onClick}>
      {children}
    </Button>
  );
};
